import axios from "axios";

export const state = {
    savings: [],
};

export const getters = {
    savings: state => state.savings,
};

export const mutations = {
    setSavings(state, newValue) {
        state.savings = newValue
    },
};

export const actions = {
    fetchSavings({ commit }) {
        axios.get('/savings').then(res => {
            commit('setSavings', res.data.savings);
        })
    },
    filterSavings({commit}, {schoolterm,year}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        let url = "/filtersavings";
        axios.post(url, formData).then((response) => {
            commit('setSavings', response.data.savings)
        })
    },
   
};
